import { usePathname } from 'next/navigation';

export const useIsPlpPage = () => {
  const pathname = usePathname();

  return pathname === '/[...slug]' && pathname?.startsWith('/subscribe');
};
